import { StatCard } from './stat-card';
import type { StatsData } from '../../model/types';

interface MovementsStatsProps {
  stats: StatsData | null;
}

export function MovementsStats({ stats }: MovementsStatsProps) {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <StatCard label="Total Volume Received" value={stats.totalVolume} />
      <StatCard label="Lost" value={stats.lossTotal} variant="destructive" />
      <StatCard label="Damaged" value={stats.damageTotal} variant="warning" />
      <StatCard label="Long Standing Stock" value={stats.longStandingPerc} />
    </div>
  );
}
